import { useState, ReactNode } from 'react'
import { EmailContext } from './email'


interface EmailProviderProps {
  children: ReactNode
}

export const EmailProvider = ({ children }: EmailProviderProps) => {
  const [email, setEmail] = useState('')
  const [isEmailValidated, setEmailValidated] = useState(false)
  const isEmailEntered = email.length > 0

  return (
    <EmailContext.Provider value={{ email, setEmail, isEmailEntered, isEmailValidated, setEmailValidated }}>
      {children}
    </EmailContext.Provider>
  )
}
